import config from 'constants/config'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

function getIsLoyaltyEnabled(state: App.State): boolean {
  if (!config.LUX_LOYALTY_ENABLED) {
    return false
  }

  if (state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.luxLoyaltyFeatureToggle]) {
    return true
  }

  // NOTE: This is turned off temporary as of 9/4/2025
  // To be turned back on once we want to start enrolling special gold members
  // if (
  //   (state.auth.account.isSpoofed && goldMemberWhiteListIds.has(state.auth.account.memberId)) ||
  //   (goldMemberWhiteListIds.has(state.auth.account.memberId) && state.loyalty.account.data)
  // ) {
  //   return true
  // }

  return false
}

export default getIsLoyaltyEnabled
